import React from 'react'
import { makeStyles, Switch, Hidden, Tooltip } from '@paintscout/ui'
import { useClientOptions } from '@paintscout/ui-business'
import { getObjectLabels } from '@paintscout/util/builder'

const useStyles = makeStyles(
  {
    switch: {
      margin: 0,
      '@media print': {
        display: 'none'
      }
    }
  },
  { name: 'AmountHeadColumn' }
)
export default function AmountHeadColumn({
  consumer,
  disabled,
  onChange,
  showAmount,
  isEditable,
  hideLabel,
  disabledTooltip
}: {
  consumer: string
  isEditable?: boolean
  showAmount?: boolean
  disabled?: boolean
  hideLabel?: boolean
  disabledTooltip?: React.ReactNode
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void
}) {
  const classes = useStyles({})
  const { options } = useClientOptions()
  const { currency } = getObjectLabels({ options })
  const showSwitch = isEditable

  // Wrap the switch in a Tooltip explaining why it's disabled (e.g. a customized
  // total price or a hidden service fee), since a bare disabled switch gives no context.
  const renderSwitch = () => {
    const switchEl = (
      <Switch
        className={classes.switch}
        data-testid="amount-column-switch"
        color={'default'}
        disabled={disabled}
        overlay={currency.symbol}
        onChange={onChange}
        checked={showAmount}
      />
    )

    if (disabled && disabledTooltip) {
      return (
        <Tooltip content={disabledTooltip} placement="bottom" hideIcon>
          {switchEl}
        </Tooltip>
      )
    }

    return switchEl
  }

  if (consumer === 'crew') {
    if (showSwitch) {
      return renderSwitch()
    } else {
      return (
        <Hidden smDown implementation="css">
          {hideLabel ? '' : 'Hours'}
        </Hidden>
      )
    }
  }

  if (consumer === 'customer') {
    if (showSwitch) {
      return renderSwitch()
    } else {
      return (
        <Hidden smDown implementation="css">
          {hideLabel ? '' : currency.symbol}
        </Hidden>
      )
    }
  }

  return null
}
